<template>
  <div class="game_details">
    <div class="title">
      <router-link :to="{name:'Home'}">首页</router-link>
      <router-link :to="{name:'AllGame'}">&emsp;<span class="Breadcrumb"><i class="el-icon-arrow-right "></i></span>&emsp;全部游戏
      </router-link>
      <router-link
        :to="this.$route.query.game_id == '26'?{name:'SelectGame',query:{game_id:this.$route.query.game_id,game_alias:'yuanshen5'}}:{name:'SelectGame',query:{game_id:this.$route.query.game_id,game_alias:'games'}}">
        &emsp;<span class="Breadcrumb"><i class="el-icon-arrow-right "></i></span>&emsp;{{ game_name }}
      </router-link>
      <a>&emsp;<span class="Breadcrumb"><i class="el-icon-arrow-right "></i></span>&emsp;账号详情</a>
    </div>
    <div v-if="can_show" class="details">
      <div class="details_info">
        <div class="DI_base_img">
          <div slot="reference">
            <el-skeleton :loading="loading"  animated>
              <template slot="template">
                <el-skeleton-item
                  variant="image"
                  style="width: 520px"
                  :style="accountInfo.id_api_shangjia?'':'height:290px'"
                />
              </template>
              <template>
                <el-image
                  style="width: 520px"
                  :style="accountInfo.id_api_shangjia?'':'height:290px'"
                  :src="accountInfo.image"
                  fit="cover"
                  :preview-src-list="srcList">
                  <div slot="placeholder" class="image-slot">
                    图片加载中<span class="dot">...</span>
                  </div>
                </el-image>
              </template>
            </el-skeleton>
          </div>
        </div>
      </div>
      <aside class="pdp-side">
        <div class="tcard">
        <div class="DI_base_content">
          <el-skeleton :loading="loading"  animated>
            <template slot="template">
              <div style="display: flex;align-items: center">
                <el-skeleton-item rows="1" animated/>
              </div>
            </template>
            <template>
              <div class="DI_prodct_tip">
                温馨提示：工作时间9：30-00：30，官网首页“客服验证”核验客服身份
              </div>
            </template>
          </el-skeleton>

          <el-skeleton :loading="loading"  animated>
            <template slot="template">
              <div class="DI_prodct_price">
                <el-skeleton-item style="width: 300px" rows="1" variant="text" animated/>
                <el-skeleton-item style="width: 60px" rows="1" variant="text" animated/>
              </div>
            </template>
            <template>
              <div class="DI_prodct_price">
                <div id="DI_prodct_price" v-if="accountInfo.price > 0">
                  <sell-sincerity v-show="accountInfo.is_willing == 1"></sell-sincerity>
                  商品价格：
                  <div class="price">¥{{ accountInfo.price }}</div>
                  <img src="@/assets/image/AllGame/isSign.png" alt="">
                  <div class="renewalTap" v-if="accountInfo.is_renewal === 1 && accountInfo.acc_source === 1">
                    <img src="@/assets/image/AllGame/renewalTap.png" alt="">
                    <div class="renewalTooltip">
                      此账号来源为游严选购买
                    </div>
                  </div>
                </div>
                <div id="DI_prodct_hot">
                  <img src="@/assets/image/Home/topGamesIco.png" alt="">
                  <span>{{ accountInfo.click }}</span>
                </div>
              </div>
            </template>
          </el-skeleton>

          <el-skeleton :loading="loading"  animated>
            <template slot="template">
              <div class="DI_prodct_zone">
                <el-skeleton-item style="width: 40%;margin: 0 50px 0 0" variant="h3" v-for="index in 4" animated
                                  :key="index"/>
              </div>
            </template>
            <template>
              <div class="DI_prodct_zone">
                <div v-for="(categoryItem,index) in accountInfo.category" :key="index" id="DI_prodct_zone">
                  <div class="zone_title">
                    {{ categoryItem.name }}：
                  </div>
                  <div class="zone_content">{{ categoryItem.value }}</div>
                </div>
              </div>
            </template>
          </el-skeleton>

          <el-skeleton :loading="loading"  animated>
            <template slot="template">
              <div style="display: flex;align-items: center">
                <el-skeleton-item rows="1" animated/>
              </div>
            </template>
            <template>
              <div class="DI_prodct_promise">
                <div class="promise_title">
                  服务承诺：
                </div>
                <div class="promise_list">
                  <div class="promise_item">
                    <img src="@/assets/image/AllGame/promise2.png" alt="">
                    找回包赔
                  </div>
                  <div class="promise_item">
                    <img src="@/assets/image/AllGame/promise4.png" alt="">
                    合同保障
                  </div>
                  <div class="promise_item">
                    <img src="@/assets/image/AllGame/promise3.png" alt="">
                    百人团队
                  </div>
                </div>
              </div>
            </template>
          </el-skeleton>
          <el-skeleton :loading="loading"  animated>
            <template slot="template">
              <div style="display: flex;align-items: center">
                <el-skeleton-item rows="1" animated/>
              </div>
            </template>
            <template>
              <div class="DI_prodct_bottom">
                <div class="prodct-bottom-left">
                  <div class="collect">
                    <img src="@/assets/image/AllGame/icon-collect.png" alt="">{{accountInfo.collect}}
                  </div>
                  <div class="collect" v-if="accountInfo.number>0">
                    <img src="@/assets/image/AllGame/icon-paimai.png" alt="">
                    <bargainPublicity :contentText="accountInfo.number+'人出价'" :number="accountInfo.number" :detailsData="accountInfo.new_bargain_list"></bargainPublicity>
                    <i class="el-icon-arrow-right"></i>
                  </div>
                </div>
                <div class="prodct-bottom-right">
                  上架时间：
                  <span>{{accountInfo.sort_date}}</span>
                </div>
              </div>
            </template>
          </el-skeleton>
          <!--          <div class="DI_prodct_addDate">
                      <div class="times" v-if="accountInfo.game_alias === 'qqsg'">
                        <div v-if="accountInfo.acc_source == 0">
                          该账号首次在游严选平台出售
                        </div>
                        <div v-else-if="accountInfo.acc_source == 1">
                          该账号在游严选平台已有<span class="transactions_num">{{ accountInfo.transactions_num }}</span>次交易
                        </div>
                        <div v-else-if="accountInfo.acc_source == 2">
                          其他平台购买（入手满6个月）
                        </div>
                        <div v-else-if="accountInfo.acc_source == 3">
                          其他平台购买（入手未满6个月）
                        </div>
                      </div>
                      <div class="up_time">
                        上架时间：
                        <span>{{ accountInfo.up_time|moment }}</span>
                      </div>
                    </div>-->
        </div>
      <div class="DI_btnGroup" v-if="accountInfo.button_show">
        <div class="DI_btnGroup_left">
          <el-skeleton :loading="loading"  animated>
            <template slot="template">
              <div style="display: flex;align-items: center">
                <el-skeleton-item style="flex-shrink: 0;margin: 0 5px" variant="button" v-for="index in 2" animated
                                  :key="index"/>
              </div>
            </template>
            <template>
              <div class="DI_btnGroup_left_inner">
                <div v-if="!accountInfo.is_collect" @click="collectClick();ProductDetailOperation('collect')" class="collectBtn"
                     @mouseleave="collecIcon='pxb7-star'" @mouseenter="collecIcon='pxb7-star-full'">
                  <i class="iconfont" :class="collecIcon"></i>
                  点击收藏
                </div>
                <div v-else @click="collectClick" class="isCollectBtn">
                  <i class="iconfont pxb7-star-full"></i>
                  已收藏
                </div>
                <div class="shareBtnWrap" @click="ProductDetailOperation('share')">
                  <share :game_alias="accountInfo.game_alias" :game_id="game_id" :game_name="game_name" :name="accountInfo.name" :id="id" ></share>
                </div>
              </div>
            </template>
          </el-skeleton>
        </div>
        <div class="DI_btnGroup_right">
          <el-skeleton :loading="loading"  animated>
            <template slot="template">
              <div style="display: flex;align-items: center;">
                <el-skeleton-item style="width:186px;height:60px;margin: 0 5px" variant="button" v-for="index in 3" animated
                                  :key="index"/>
              </div>
            </template>
            <template>
              <div v-if="showBargin" class="priceCutBtn btn" @click="seeking_price_cuts_confirm();ProductDetailOperation('priceCut')">
                求降价
              </div>
              <div @click.stop="cusSerBtnClicks()" class="cusSerBtn btn">
                咨询客服
              </div>
              <div @click="ProductDetailOperation('buy')">
                <a v-if="(sys_service_type==2||sys_service_type==3)&&is_online_purchase == 0" @click="cusSerBtnClicks('buy')" class="onlineDealBtn btn">立即购买</a>
                <a v-else-if="(sys_service_type==2||sys_service_type==3)&&is_online_purchase == 1" @click="onlineBuy" class="onlineDealBtn btn">立即购买</a>
                <a v-if="sys_service_type!=2&&sys_service_type!=3" @click="cusSerBtnClick('buy')" class="onlineDealBtn btn">
                  立即购买
                </a>
              </div>
              <!-- <div class="onlineDealBtn btn" @click="onlineBuy">立即购买</div> -->
              <!-- <div @click.stop="cusSerBtnClicks()" class="cusSerBtn btn">
                <img src="@/assets/image/AllGame/gameDetails/cusSerIcon.png" alt="">
                咨询
              </div> -->
              <!-- <div v-else @click.stop="cusSerBtnClick()" class="cusSerBtn btn">
                <img src="@/assets/image/AllGame/gameDetails/cusSerIcon.png" alt="">
                咨询客服
              </div> -->
            </template>
          </el-skeleton>
        </div>

      </div>
        </div>
      </aside>

      <div class="DI_productName">
        <div class="tag" v-if="tagList.length">
          <el-tag v-for="item in tagList"  :key="item" type="warning" size="small">{{ item }}</el-tag>
        </div>
        <el-skeleton :loading="loading"  animated>
          <template slot="template">
            <div>
              <el-skeleton-item style="width: 10%;margin: 0 20px 0 0"  variant="text" animated/>
              <el-skeleton-item style="width: calc(90% - 20px)" variant="text" animated/>
            </div>
            <div>
              <el-skeleton-item variant="text" animated v-for="index in 4" :key="index"/>
            </div>
          </template>
          <template>
            <span :class="accNameHide?'DI_productName_hide':'DI_productName_show'" ref="detailDom">
          <span class="DI_productName_title">{{ accountInfo.game_name }}</span>
          {{ accountInfo.name }}
        </span>
            <div class="DI_productName_btn" v-if="showDetailBtn" @click="accNameHide = !accNameHide">
              {{ accNameHide ? '展开全部' : '收起文字' }} <i
              :class="accNameHide?'el-icon-caret-bottom':'el-icon-caret-top'"></i>
            </div>
          </template>
        </el-skeleton>

      </div>
      <div class="DI_links">
        <el-skeleton :loading="loading"  animated>
          <template slot="template">
            <div style="display: flex;align-items: center">
              <el-skeleton-item style="width: 25%;margin: 0 20px" variant="button" v-for="index in 4" animated
                                :key="index"/>
            </div>
          </template>
          <template>
            <div class="labels">
              <!--          <router-link :to="{name:'TradeTip',query:{id:'110',parent_id:'83'}}">-->
              <!--            分期购-->
              <!--          </router-link>-->
              <a>
                账号安全解析
              </a>
              <router-link :to="{name:'TradeTip',query:{id:'112',parent_id:'83'}}">
                投诉建议
              </router-link>
              <router-link :to="{name:'Legal',query:{id:'15',parent_id:'13'}}">
                找回包赔
              </router-link>
              <!-- <el-popover v-if="this.game_id == 15" placement="left" width="600" trigger="click">
                <el-image :src="require('../../../assets/image/AllGame/qqsg.jpg')"></el-image>
                <span slot="reference">免费估价</span>
              </el-popover> -->
              <!-- <a v-if="game_id != 15&&sys_service_type!=2" :href="accountInfo.game_customer" target="_blank">
                免费估价
              </a> -->
              <div v-if="game_id != 15&&(sys_service_type==2||sys_service_type==3)" style="cursor: pointer;" @click="goValuation">
                免费估价
              </div>
            </div>
          </template>
        </el-skeleton>
      </div>
      <div class="details_tabbar">
        <el-skeleton :loading="loading"  animated>
          <template slot="template">
            <div style="display: flex;align-items: center;padding: 20px 40px;">
              <el-skeleton-item style="width: 10%;margin: 0 10px" variant="button" v-for="index in 4" animated
                                :key="index"/>
            </div>
            <div style="padding: 20px 40px;">
              <el-skeleton-item variant="image" style="width: 100%;height:300px;margin: 0 0 10px" v-for="index in 3" :key="index"/>
            </div>
          </template>
          <template>
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane label="游戏资产" name="assets" v-if="showAssetsTab">
                <game-assets
                  :groups="dto.assets.groups || []"
                  :lab="(dto.gallery && dto.gallery.lab) || []"
                  :summary="dto.summary || {}"></game-assets>
              </el-tab-pane>
              <el-tab-pane label="账号详情" name="first">
                <!-- 采集源图片详情(dd_accuprice_media · detail) —— 富文本为空时的主要详情展示 -->
                <div class="detail_gallery" v-if="detailImages.length">
                  <el-image
                    v-for="(url, i) in detailImages"
                    :key="i"
                    :src="url"
                    :preview-src-list="detailImages"
                    fit="contain"
                    lazy
                    class="detail_gallery_img"/>
                </div>
<!--                <div class="Tip12" v-if="sys_service_type == '2'">
                  <img src="@/assets/image/AllGame/notice.png" alt="" class="JL_tip">
                </div>-->
<!--                <div v-if="game_id == '15'" class="Tip15">
                  <img v-if="category15Img" :src="category15Img" alt="">
                  <img v-else src="@/assets/image/AllGame/emegencyNotice2.png" alt=""
                       @click="emegencyNotice2Click" style="cursor: pointer">
                </div>
                <div v-else-if="game_id == '10'" class="Tip">
                  <img src="@/assets/image/AllGame/JL_tip.png" alt="" class="JL_tip">
                  <img src="@/assets/image/AllGame/JL_tipBtn.png" alt="" class="JL_tipBtn"
                       @click="gotoLink('https://jq.qq.com/?_wv=1027&k=bpmHpZUb')">
                </div>
                <div class="Tip12" v-else-if="game_id == '12'">
                  <img src="@/assets/image/AllGame/YXLM_tip.png" alt="" class="JL_tip">
                </div>
                <div class="Tip12" v-else-if="game_id == '26'">
                  <img src="@/assets/image/AllGame/YS_tip.png" alt="" class="JL_tip">
                </div>
                <div class="Tip12" v-else-if="game_id == '13'">
                  <img src="@/assets/image/AllGame/WZRY_tip.png" alt="" class="JL_tip">
                </div>
                <div class="Tip12" v-else-if="game_id == '44'">
                  <img src="@/assets/image/AllGame/NZ_tip.png" alt="" class="JL_tip">
                </div>
                <div class="Tip12" v-else-if="game_id == '45'">
                  <img src="@/assets/image/AllGame/SLDFZ_tip.png" alt="" class="JL_tip">
                </div>
                <div class="Tip12" v-else-if="game_id == '50'">
                  <img src="@/assets/image/AllGame/APEX_tip.png" alt="" class="JL_tip"
                       @click="gotoLink('https://jq.qq.com/?_wv=1027&k=013smWh4')">
                </div>
                <div class="Tip12" v-else-if="game_id == '51'">
                  <img src="@/assets/image/AllGame/ZCPMS_tip.png" alt="" class="JL_tip"
                       @click="gotoLink('https://jq.qq.com/?_wv=1027&k=1QLB1Rof')">
                </div>
                <div class="Tip12" v-else-if="game_id == '49'">
                  <img src="@/assets/image/AllGame/DNFSY_tip.png" alt="" class="JL_tip"
                       @click="gotoLink('https://jq.qq.com/?_wv=1027&k=Fn2ofhxE')">
                </div>
                <div class="Tip12" v-else-if="game_id == '53'">
                  <img src="@/assets/image/AllGame/MRFZ.png" alt="" class="JL_tip">
                </div>
                <div class="Tip12" v-else-if="game_id == '56'">
                  <img src="@/assets/image/AllGame/FOG.png" alt="" class="JL_tip">
                </div>
                <div class="Tip12" v-else-if="game_id == '61'">
                  <img src="@/assets/image/AllGame/SGS.png" alt="" class="JL_tip"
                       @click="gotoLink('https://jq.qq.com/?_wv=1027&k=N6u2ZN01')">
                </div>
                <div class="Tip12" v-else-if="game_id == '52'">
                  <img src="@/assets/image/AllGame/SMZHSY.png" alt="" class="JL_tip">
                </div>
                <div class="Tip12" v-else-if="game_id == '73'">
                  <img src="@/assets/image/AllGame/FKJYOL.png" alt="" class="JL_tip">
                </div>
                <div class="Tip12" v-else-if="game_id == '85'">
                  <img src="@/assets/image/AllGame/PPKDC.png" alt="" class="JL_tip"
                       @click="gotoLink('https://jq.qq.com/?_wv=1027&k=uZ1z9Und')">
                </div>
                <div class="Tip12" v-else-if="game_id == '86'">
                  <img src="@/assets/image/AllGame/JTLQ.png" alt="" class="JL_tip"
                       @click="gotoLink('https://jq.qq.com/?_wv=1027&k=uUTR3ZRP')">
                </div>
                <div class="Tip12" v-else-if="game_id == '87'">
                  <img src="@/assets/image/AllGame/NK.png" alt="" class="JL_tip"
                       @click="gotoLink('https://jq.qq.com/?_wv=1027&k=fc8izbOm')">
                </div>
                <div class="Tip12" v-else-if="game_id == '88'">
                  <img src="@/assets/image/AllGame/ABD.png" alt="" class="JL_tip"
                       @click="gotoLink('https://jq.qq.com/?_wv=1027&k=Oz9KYHmF')">
                </div>
                <div class="Tip12" v-else-if="game_id == '71'">
                  <img src="@/assets/image/AllGame/QSJ.png" alt="" class="JL_tip">
                </div>
                <div class="Tip12" v-else-if="game_id == '72'">
                  <img src="@/assets/image/AllGame/BLCT.jpg" alt="" class="JL_tip"
                       @click="gotoLink('https://jq.qq.com/?_wv=1027&k=hU4Gzt4i')">
                </div>
                <div class="Tip12" v-else-if="game_id == '78'">
                  <img src="@/assets/image/AllGame/OW2.png" alt="" class="JL_tip">
                </div>
                <div class="Tip12" v-else-if="game_id == '81'">
                  <img src="@/assets/image/AllGame/JZPAJ.png" alt="" class="JL_tip">
                </div>
                <div class="Tip12" v-else-if="game_id == '128'">
                  <img src="@/assets/image/AllGame/NIKKE.png" alt="" class="JL_tip"
                       @click="gotoLink('https://jq.qq.com/?_wv=1027&k=YeuFCfz1')">
                </div>
                <div class="Tip12" v-else-if="game_id == '130'">
                  <img src="@/assets/image/AllGame/WLLT.jpg" alt="" class="JL_tip"
                       @click="gotoLink('https://jq.qq.com/?_wv=1027&k=ZbptFlvk')">
                </div>
                <div class="Tip12" v-else-if="game_id == '131'">
                  <img src="@/assets/image/AllGame/ZY.png" alt="" class="JL_tip"
                       @click="gotoLink('https://jq.qq.com/?_wv=1027&k=PTp0xdEX')">
                </div>
                <div class="Tip12" v-else-if="game_id == '139'">
                  <img src="@/assets/image/AllGame/SSCZ.png" alt="" class="JL_tip"
                       @click="gotoLink('https://jq.qq.com/?_wv=1027&k=RZOhxb6e')">
                </div>
                <div class="Tip12" v-else-if="game_id == '143'">
                  <img src="@/assets/image/AllGame/DDT.jpg" alt="" class="JL_tip"
                       @click="gotoLink('https://jq.qq.com/?_wv=1027&k=YxmeYf5F')">
                </div>
                <div class="Tip12" v-else-if="game_id == '142'">
                  <img src="@/assets/image/AllGame/DZPD.png" alt="" class="JL_tip"
                       @click="gotoLink('https://jq.qq.com/?_wv=1027&k=C97GskxE')">
                </div>
                <div class="Tip12" v-else-if="game_id == '146'">
                  <img src="@/assets/image/AllGame/ZHJ.png" alt="" class="JL_tip"
                       @click="gotoLink('https://jq.qq.com/?_wv=1027&k=fKbwWfUv')">
                </div>-->
                <div class="first_content ql-container ql-snow" v-if="self_publicize">
                  <p class=" ql-editor" v-html="self_publicize"></p>
                </div>
<!--                <div class="Tip12" v-else-if="game_id == '74'">-->
<!--                  <img src="@/assets/image/AllGame/SZJJ.jpeg" alt="" class="JL_tip"-->
<!--                       @click="gotoLink('https://jq.qq.com/?_wv=1027&k=pDL1MzuB')">-->
<!--                </div>-->
                <div class="first_content ql-container ql-snow" v-if="richContent">
                  <p class=" ql-editor" v-html="richContent"></p>
                </div>
                <div class="first_content ql-container ql-snow" v-if="richCdata">
                  <p class=" ql-editor" v-html="richCdata"></p>
                </div>
              </el-tab-pane>
              <el-tab-pane label="装备包赔" name="sixth" v-if="accountInfo.game_reparation">
                <div class="third_content">
                  <div v-html="accountInfo.game_reparation"></div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="交易须知" name="third">
                <div class="third_content">
                  <div v-html="accountInfo.game_notice"></div>
<!--                  <img src="@/assets/image/AllGame/Tran_Notice.png" alt="">-->
                </div>
              </el-tab-pane>
              <el-tab-pane label="包赔介绍" name="fifth">
                <div class="third_content">
                  <div v-html="accountInfo.game_introduce"></div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="交易群" name="fourth">
                <div class="fourth_content">
                  <div class="fourth_content_item" v-for="(item,index) in qqGrounp" :key="index">
                    <div class="fourth_content_item_box">
                      <div>
                        <img src="@/assets/image/AllGame/contentItemTitle.png" alt="">
                      </div>
                      <div class="qq_logo">
                        <img src="@/assets/image/AllGame/QQlogo.png" alt="">
                      </div>
                      <div class="group_name">{{ item.name }}</div>
                      <a class="add_group" target="_blank" :href="item.link">点击加群</a>
                    </div>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </template>
        </el-skeleton>

      </div>
    </div>
    <div v-else class="showFalse">
      <div class="showFalse_tip">
        <img src="@/assets/image/AllGame/showFalse.png" alt="">
      </div>
      <div class="showFalse_btnG">
        <router-link id="back" :to="{name:'Home'}">返回首页</router-link>
        <a class="cusSer" href="#" @click="cusSerBtnClicks()">联系客服</a>
        <!-- <a v-else class="cusSer" target="_blank" :href="accountInfo.game_customer">联系客服</a> -->
      </div>
    </div>
    <mydialog :text="'尊敬的游严选VIP您好，根据相关法律法规要求，需实名认证方可进行购买。'" :btn-text="'去实名'" btn :show="realNameShow"
              :close-fun="mydialogClose" :btn-fuc="mydialogBtnClick"
    ></mydialog>
    <left-product v-if="game_id == 26" :product_id="id" :game_id="game_id"></left-product>
    <buyer-to-sell-on-chat @cusSers="cusSers()" @cusSell="cusSell()" :visible.sync="ssmQuestion"></buyer-to-sell-on-chat>
    <el-dialog
      :visible.sync="valuationDialog"
      custom-class="reductionDia"
      :show-close="false"
      width="328px"
      top="35vh"
      center>
      <span>
        <div id="UPS_main">
          <div class="UPS_info">
            <img src="@/assets/image/AllGame/gameDetails/reduction_top.png" alt="">
            <div class="reductionbg">
              <div class="reductionbg_price">
                <div class="reductionbg_price_left">
                  <div>￥<span>{{myBargain.bargain_price}}</span></div>
                  <div>最终协商价</div>
                </div>
                <div class="reductionbg_price_right">
                  <div>有效期截止至：</div>
                  <div>{{myBargain.effective_time}}</div>
                </div>
              </div>
              <div v-if="(sys_service_type==2||sys_service_type==3)&&is_online_purchase == 0" class="reduction_btn" @click="valuationDialog=false,cusSerBtnClicks('buy')">立即购买</div>
              <div v-else-if="(sys_service_type==2||sys_service_type==3)&&is_online_purchase == 1" class="reduction_btn" @click="valuationDialog=false,onlineBuy()">立即购买</div>
              <div v-if="sys_service_type!=2&&sys_service_type!=3" class="reduction_btn" @click="valuationDialog=false,cusSerBtnClick('buy')">立即购买</div>
            </div>
          </div>
        </div>
        <img class="UPS_close" style="left:149px" src="@/assets/image/AccountDeal/close.png" alt="" @click="valuationDialog = false">
      </span>
    </el-dialog>
    <mydialog title="提示" text="该商品已在议价中，请前往议价详情查看" :close-fun="()=>barginShow=false"  :show="barginShow">
        <div slot="btn" class="dialog-footer">
          <el-button class="btn-cancel" @click="barginShow=false">取消</el-button>
          <el-button class="btn-confirm" @click="goBarginList">议价详情</el-button>
        </div>
    </mydialog>
    <mydialog title="提示" :show="barginChangeShow" text="当前商品已开启新求降价，建议您重新出价！" :closeFun="() =>barginChangeShow = false">
      <div slot="btn">
        <el-button class="wait" @click="barginChangeShow = false">继续等待</el-button>
        <el-button class="reBargin" @click="reBargin">重新出价</el-button>
      </div>
    </mydialog>
    <sincerely-buy ref="sincerely" :range="range" @reFresh="onLoad"></sincerely-buy>
  </div>
</template>

<script>
import {
  apiProductInfo,
  apiAccountDetailDto,
  apiCollectSet,
  apiBargainAdd,
  apiBargainClcik,
  apiCustomerRandom,
  apiHistoryCusAdd,
  apiHistoryProductAdd,
  apiuserInfo, apiStatisticsAdd,
  apiGameInfo,
  apiProductBuyCheck,
  apigetSnapUp,
  apiConsult,
  apiMyBargain,
  createPrepare,
  bargianStatus,
  delOldBargin
} from "@/request/API";
import LeftProduct from "@/components/leftProduct";
import mydialog from "@/components/myDialog";
import share from "@/components/share"
import bargainPublicity from "@/components/bargainPublicity"
import BuyerToSellOnChat from './components/buyerToSellOnChat.vue';
import SellSincerity from '../components/sellSincerity.vue';
import sincerelyBuy from './components/sincerelyBuy.vue'
import GameAssets from './components/gameAssets.vue'

export default {
  name: '',
  components: {
    LeftProduct,
    mydialog,
    share,
    BuyerToSellOnChat,
    SellSincerity,
    sincerelyBuy,
    bargainPublicity,
    GameAssets
  },
  data() {
    return {
      myBargain: {
        bargain_price: '0',
        effective_time: ''
      },
      valuationDialog: false,
      //游戏名称
      game_name: '',
      //游戏id
      game_id: this.$route.query.game_id,
      //账号id
      id: this.$route.query.id,
      // 当前选中tabbar
      activeName: 'first',
      // 交易qq群
      qqGrounp: [],
      //账号详情
      accountInfo: {
        image: ''
      },
      can_show: true,
      srcList: [],
      //账号标题隐藏
      accNameHide: true,
      showDetailBtn: false,
      detailDom: '',
      //qq三国 按服务器
      category15: '',
      category15Img: '',
      //立即购买 实名弹窗
      realNameShow: false,
      //收藏图标
      collecIcon: 'pxb7-star',
      //收藏图标
      shareIcon: 'pxb7-share',
      // 是否53客服/游严选客服
      sys_service_type: 0,
      //是否开启在线购买
      is_online_purchase: 0,
      loading: true,
      msg:{},
      ssmQuestion: false,
      is_open_trans_chat: 0,
      is_merchant_no: 1,
      //自主宣传图 账号详情首图
      self_publicize:'',
      barginShow:false,
      range:{},
      exist_type:'',
      barginChangeShow:false,
      //多数据源归一详情(游戏资产/图集/采集) —— 不影响原有交易逻辑
      dto: null
    }
  },
  methods: {
    // F-01 守卫：仅当值是合法富文本 HTML 时才返回，否则返回 '' 以隐藏对应 v-html 块。
    // F-01c 加固：后台 Quill 会把裸 JSON 规范化成 <p>{...}</p>，绕过单纯的 s[0]==='{' 判断。
    // 因此先剥离所有 HTML 标签得到纯文本，再据纯文本判定是否为 JSON，杜绝被标签包裹的 JSON 泄露。
    asRichText(val) {
      if (typeof val !== 'string') return ''
      const s = val.trim()
      if (!s) return ''
      // 去标签纯文本：优先用 DOMParser 解析到惰性文档取 textContent（顺带解码实体、
      // 不执行脚本、不加载资源），不可用时回退正则。
      let plain = ''
      try {
        if (typeof DOMParser !== 'undefined') {
          const doc = new DOMParser().parseFromString(s, 'text/html')
          plain = ((doc.body && doc.body.textContent) || '').trim()
        } else {
          plain = s.replace(/<[^>]*>/g, '').trim()
        }
      } catch (e) {
        plain = s.replace(/<[^>]*>/g, '').trim()
      }
      // 去标签后无任何可见文本（纯空标签）→ 不渲染。
      if (!plain) return ''
      // 纯文本以 { 或 [ 开头（裸 JSON 或被标签包裹的 JSON）→ 不渲染。
      if (plain[0] === '{' || plain[0] === '[') return ''
      // 必须含真实 HTML 标签才视为富文本。
      if (!/<[a-z][\s\S]*>/i.test(s)) return ''
      return val
    },
    // 免费估价
    goValuation() {
      if (this.$route.query.seo == 1) {
        this.$router.push('/accountValuation')
      }
    },
    reBargin() {
      delOldBargin({
         product_id: this.id,
          game_id: this.game_id
        }).then(res=>{
          this.barginChangeShow = false
          this.onLoad()
      })
    },
    goBarginList() {
      // exist_type  1跳老的 2跳新的
      let path = ''
      switch (this.exist_type) {
        case 1:
          path = '/personalCenter/buyer/bargain'
          break;
        case 2:
          path = '/personalCenter/buyer/bargainPrice'
          break;
      }
      this.$router.push({
        path
      })
    },
    /**
     * @description: 咨询卖家
     * @return {*}
     */
    async cusSell() {
      let userInfo = await apiuserInfo({action: 'verified'})
      if (
          (userInfo.data.cert_id === '' &&
          this.$store.state.systemInfo.real_name_auth == '1' &&
          this.$store.state.userData.country_code == '86') ||
          (userInfo.data.cert_id === '' &&
          this.$store.state.systemInfo.real_name_auth == '0')
        ) {
        this.realNameShow = true
        this.ssmQuestion = false
        return
      }
      apiConsult({
        game_id: this.game_id,
        goods_id: this.id
      }).then(res => {
        this.ssmQuestion = false
        this.$openIM({
          room_id: res.data.room_id,
          gameAlias: this.accountInfo.game_alias
        })
      }).catch(e => {})
    },
    cusSers() {
      this.statisticsAdd(3)
      if(this.id && this.game_id){
        this.$customerShunt.getBuyOrGroupCode(this.id, this.game_id, 1, (data) => {
          // 当前游戏是否开启在线支付
          if(data.game_buy_status){
            // 当前规则是否开启在线支付
            data.allot_group_buy_status ? this.onlineBuy() : this.$openIM({
              product_id: this.id,
              game_id: this.game_id,
              shopid: this.id,
              product_type: 1,
              gameAlias: data.group_code,
              im_type: 3
            })
          } else {
            this.$openIM({
              product_id: this.id,
              game_id: this.game_id,
              shopid: this.id,
              product_type: 1,
              gameAlias: data.group_code,
              im_type: 3
            })
          }
        })
      } else {
        this.$openIM({
          product_id: this.id,
          game_id: this.game_id,
          shopid: this.id,
          product_type: 1,
          gameAlias: this.accountInfo.game_alias
        })
      }
    },
    async cusSerBtnClicks(type) {
      if (this.$store.state.loginStatus) {
        let userInfo = await apiuserInfo({action: 'verified'})
        if (
            (userInfo.data.cert_id === '' &&
            this.$store.state.systemInfo.real_name_auth == '1' &&
            this.$store.state.userData.country_code == '86') ||
            (userInfo.data.cert_id === '' &&
            this.$store.state.systemInfo.real_name_auth == '0' &&
            type == 'buy')
          ) {
          this.realNameShow = true
          return
        }
        if(type == 'buy'){
          this.$customerShunt.getBuyOrGroupCode(this.id, this.game_id, 1, (data) => {
            if(data.game_buy_status){
              this.onlineBuy()
            } else {
              this.$openIM({
                game_id: this.game_id,
                shopid: this.id,
                product_type: 1,
                gameAlias: data.group_code,
                im_type: 3
              })
            }
          })
        }else{
          // 判断是否开启与卖家直接咨询
          if(this.is_open_trans_chat == 1&&this.accountInfo.is_merchant_no==0){
            // 卖家咨询 -- 客服咨询
            this.ssmQuestion = true
          } else {
            this.cusSers()
          }
        }
      } else {
        this.$message({
          type: "error",
          message: '尚未登录，请先登录。',
          center: true
        })
        this.$router.push({
          path: '/login',
          query: {
            Rurl: this.$route.fullPath,
            game_name: this.game_name,
            game_id: this.game_id,
            id: this.id,
          },
        })
      }
    },
    /**
     * @description: 跳转联系客服
     * @return {*}
     */
    async cusSerBtnClick(type) {
      if (this.$store.state.loginStatus) {
        let userInfo = await apiuserInfo({action: 'verified'})
        if (
            (userInfo.data.cert_id === '' &&
            this.$store.state.systemInfo.real_name_auth == '1' &&
            this.$store.state.userData.country_code == '86') ||
            (userInfo.data.cert_id === '' &&
            this.$store.state.systemInfo.real_name_auth == '0' &&
            type == 'buy')
          ) {
          this.realNameShow = true
          return
        }
        this.cusSers()
      } else {
        this.$message({
          type: "error",
          message: '尚未登录，请先登录。',
          center: true
        })
        this.$router.push({
          path: '/login',
          query: {
            Rurl: this.$route.fullPath,
            game_name: this.game_name,
            game_id: this.game_id,
            id: this.id,
          },
        })
      }
    },
    cusSer() {
      this.statisticsAdd(3)
      this.$accessLink(this.accountInfo.game_customer)
      this.historySerAdd()
      var api = $53.createApi()
      api.push('cmd', 'comeinfo');
      api.push('title', this.accountInfo.name);
      api.push('logo', this.accountInfo.image);
      api.push('content', `商品价格:${this.accountInfo.price}`);
      api.push('curl', location.href);
      api.query();
      api.push('cmd', 'kfclient');
      api.push('type', 'new');
      api.push('group_id', this.accountInfo.buy_group);
      api.query();
    },
    /**
     * 关闭实名认证提示框
     */
    mydialogClose() {
      this.realNameShow = false
    },
    mydialogBtnClick() {
      this.$router.push({
        path: '/personalCenter/personalInfo/rNameAuthentication',
        query: {
          Rurl: this.$route.fullPath,
        },
      })
    },
    //复制微信
    contactCusSer_copy(wechat) {
      var text = wechat;
      var input = document.getElementById("input");
      input.value = text; // 修改文本框的内容
      input.select(); // 选中文本
      document.execCommand('copy'); // 执行浏览器复制命令
      this.$message({
        type: "success",
        center: true,
        message: '复制成功'
      })
    },
    handleClick(tab, event) {
    },
    /**
     * 收藏按钮
     */
    collectClick() {
      if (this.$store.state.loginStatus) {
        apiCollectSet({
          game_id: this.game_id,
          acc_id: this.id,
        }).then(res => {
          this.accountInfo.is_collect = res.data.is_collect
        }).catch(err => {
          this.$message({
            type: "error",
            center: true,
            message: err.msg
          })
        })
      } else {
        this.$message({
          type: "error",
          message: '尚未登录，请先登录。',
          center: true
        })
        this.$router.push({
          path: '/login',
          query: {
            Rurl: this.$route.fullPath,
            game_name: this.game_name,
            game_id: this.game_id,
            id: this.id,
          },
        })
      }
    },
    useNewBargin() {
      if(this.accountInfo.can_bargain && this.accountInfo.accept_bargain == 1) {
          createPrepare({
            product_id: this.id,
            game_id: this.game_id,
          }).then((res) => {
            this.range = res.data
            if (res.data.my_status){
              this.$refs.sincerely.dialogVisible = true
            } else {
              // 存在相同商品的求降价订单 打开弹窗跳转   已和后端确认bargianStatus接口返回数据一致
              this.barginShow = true
            }
          }).catch(err=>{
            this.$message.error(err.msg)
          })
      }
    },
    // 求降价
    async  seeking_price_cuts_confirm() {
      apiBargainClcik({
        game_id: this.game_id,
        id: this.id,
      }).catch(err => {
        this.$message({
          type: "error",
          message: err.msg,
          center: true
        })
      })
      if (this.$store.state.loginStatus) {
        let userInfo = await apiuserInfo({action: 'verified'})
        if (
            (userInfo.data.cert_id === '' &&
            this.$store.state.systemInfo.real_name_auth == '1' &&
            this.$store.state.userData.country_code == '86') ||
            (userInfo.data.cert_id === '' &&
            this.$store.state.systemInfo.real_name_auth == '0')
          ) {
          this.realNameShow = true
          return
        }
        bargianStatus({
          product_id: this.id,
          game_id: this.game_id
        }).then(res => {
          this.exist_type = res.data.exist_type
          // exist_type 0不跳转 1跳老的 2跳新的
          switch (res.data.exist_type) {
            case 0:
              // type 0未开启求降价 1老求降价 2新求降价
               switch (res.data.type) {
                  case 0:
                    this.$message.error('未开启求降价')
                    //  重新请求详情数据
                    this.onLoad()
                    break;
                  case 1:
                    // 老求降价
                    this.useOldBargin()
                    break;
                  case 2:
                    //  新求降价
                    this.useNewBargin()
                    break;
                }
              break;

            default:
              // 存在相同商品的求降价订单 打开弹窗跳转
              this.barginShow = true;
              break;
          }

        }).catch(err => {
          this.$message.error(err?.msg)
          // 商品二次编辑   下架  改价 10012 跳详情页 10013 跳列表页
          if (err?.code === 10012 || err?.code === 10013) {
            switch (err.code) {
              case 10012:
                //  刷新当前商品
                  this.onLoad()
                break;
              case 10013:
                  this.$router.push({
                    name: "SelectGame",
                    query: {
                      game_id: this.accountInfo.game_id,
                      game_alias: this.accountInfo.game_alias === 'yuanshen' ? "yuanshen5" : "games",
                    },
                  });
                break
            }
          }
        })
      } else {
        this.$message({
          type: "error",
          message: '尚未登录，请先登录。',
          center: true
        })
        this.$router.push({
          path: '/login',
          query: {
            Rurl: this.$route.fullPath,
            game_name: this.game_name,
            game_id: this.game_id,
            id: this.id,
          },
        })
      }
    },
    //  老求降价
    useOldBargin() {
      let sell_price = 'block'
        if (this.accountInfo.sell_price == '0.00') {
          sell_price = 'none'
        }
        const h = this.$createElement;
        apiMyBargain({
          game_id: this.game_id,
          goods_id: this.id
        }).then(res => {
          this.myBargain.bargain_price = res.data.bargain_price
          this.myBargain.effective_time = res.data.effective_time
          if(this.myBargain.effective_time&&this.myBargain.bargain_price*1>0){
            this.valuationDialog = true
          }else{
            if (this.accountInfo.is_bargain) {
              this.$msgbox({
                title: '',
                message: h('div', {class: 'confirm_content'}, [
                  h('div', {class: 'confirm_original_price'}, '原价：' + this.accountInfo.price + ''),
                  h('div', {class: 'confirm_my_bid'}, '我的出价：' + this.accountInfo.bargain_price + ''),
                  h('div', {
                    class: 'confirm_my_bid',
                    style: "display:" + sell_price + ""
                  }, '卖家最低报价：' + this.accountInfo.sell_price + ''),
                  h('div', {class: 'confirm_modify_bid'}, [
                    h('div', {class: 'confirm_modify_bid_text'}, '修改出价：'),
                    h('input', {
                      class: 'confirm_modify_bid_input',
                      attrs: {placeholder: "输入修改后的价格", id: "confirm_modify_bid_input"}
                    }),
                  ]),
                  h('div', {class: 'confirm_modify_bid_tips'}, '（提示：24小时内只能求降价1次）'),
                ]),
                confirmButtonText: '确认修改',
                confirmButtonClass: 'change_price_confirm_btn',
                customClass: 'change_price_confirm',
                closeOnClickModal: false,
                showClose: true,
                callback: action => {
                  if (action === "confirm") {
                    apiBargainAdd({
                      id: this.accountInfo.bargain_id,
                      price: document.getElementById("confirm_modify_bid_input").value
                    }).then(res => {
                      this.$message({
                        message: "修改成功",
                        center: true,
                        type: 'success'
                      })
                    }).catch(err => {
                      if(err?.code === 10019) {
                        this.barginChangeShow = true
                      } else {
                        this.$message({
                          message: err.msg,
                          center: true,
                          type: 'error'
                        })
                      }
                    })
                  }
                  document.getElementById("confirm_modify_bid_input").value = ''
                }
              });
            } else {
              this.$msgbox({
                title: '',
                message: h('div', {class: 'confirm_content'}, [
                  h('div', {class: 'confirm_original_price'}, '原价：' + this.accountInfo.price + ''),
                  h('div', {class: 'confirm_modify_bid'}, [
                    h('div', {class: 'confirm_modify_bid_text'}, '我的出价：'),
                    h('input', {
                      class: 'confirm_modify_bid_input',
                      attrs: {placeholder: "输入我出的价格", id: 'confirm_modify_bid_input'}
                    }),
                  ]),
                  h('div', {class: 'confirm_modify_bid_tips'}, '（提示：24小时内只能求降价1次）'),
                ]),
                confirmButtonText: '确认发起',
                confirmButtonClass: 'change_price_confirm_btn',
                customClass: 'add_price_confirm',
                closeOnClickModal: false,
                showClose: true,
                beforeClose: (action, instance, done) => {
                  if (action === "confirm") {
                    const price = document.getElementById("confirm_modify_bid_input").value
                    if((price+'').includes('.')) {
                      this.$message({
                        type: "error",
                        message: '价格不支持小数',
                        center: true
                      })
                      return
                    }
                  }
                  done()
                },
                callback: action => {
                  if (action === "confirm") {
                    apiBargainAdd({
                      game_id: this.game_id,
                      product_id: this.id,
                      price: document.getElementById("confirm_modify_bid_input").value
                    }).then(res => {
                      this.$message({
                        center: true,
                        message: "发起降价请求成功",
                        type: 'success'
                      })
                      this.accountInfo.is_bargain = true
                      this.accountInfo.bargain_price = res.data.bargain_price
                      this.accountInfo.bargain_id = res.data.id
                    }).catch(err => {
                      if(err?.code === 10019) {
                       this.barginChangeShow = true
                      } else {
                        this.$message({
                          message: err.msg,
                          center: true,
                          type: 'error'
                        })
                      }
                    })
                  }
                  document.getElementById("confirm_modify_bid_input").value = ''
                }
              });
            }
          }
        })
    },
    //初始化数据
     async onLoad() {
      this.msg = this.$message({
        message: '页面加载中，请稍等～',
        type: 'info',
        duration:0
      })
      await apiProductInfo({
        game_id: this.game_id,
        id: this.id,
        orderId:this.$route.query.order_id,
      }).then(res => {
        this.can_show = res.data.can_show
        this.accountInfo = res.data
        let reg1 = new RegExp("x-oss-process=style/thumb");
        const srcListImg = res.data.image.replace(reg1,"");
        this.srcList.push(srcListImg)
        this.game_name = res.data.game_name
        this.qqGrounp = res.data.game_qun
        if (res.data.game_id == '15') {
          this.accountInfo.category.forEach(item => {
            try{
              if (item.name == '按服务器') {
                this.category15Img = require(`../../../assets/image/AllGame/gameDetailsTip15/广告-5 - ${item.value}.jpg`)
              }
            }catch (e) {

            }
          })
        }
        document.title = this.accountInfo.name
        this.showDetailBtnFun();
        if (res.data.game_id == '26') {
          res.data.category = [...res.data.category, ...[
            {name: '绑定TAP', value: res.data.bind_tap === 1 ? '是' : '否'},
            {name: '绑定PSN', value: res.data.bind_psn === 1 ? '是' : '否'}
          ]]
        }
        this.loading = false
        this.msg.close()
        this.$sensorsTrack.ProductDetailView(this.$route.query.source_page,`${this.accountInfo.game_alias}_${this.id}`,this.game_name,this.game_id,this.accountInfo.user_id,false,false)
      }).catch(err=>{
        this.$message({
          message: err.msg,
          type: 'error',
          duration: 2500
        })
        setTimeout(() => {
          this.msg.close()
        }, 3000);
      })

    },
    /**
     * 多数据源归一详情(游戏资产/图集) —— 独立拉取，失败不影响主流程
     */
    loadDto() {
      apiAccountDetailDto({
        game_id: this.game_id,
        id: this.id
      }).then(res => {
        this.dto = res.data
        console.log('[DTO] loaded:', res.data, 'assets.has=', this.dto && this.dto.assets && this.dto.assets.has)
        // 有结构化游戏资产/数据概览时，默认定位到「游戏资产」Tab
        if (this.showAssetsTab) {
          this.activeName = 'assets'
        }
      }).catch(err => {
        console.warn('[DTO] failed:', err && (err.msg || err.message || err), err)
      })
    },
    /**
     * 跳转链接
     * @param link 链接
     */
    gotoLink(link) {
      window.open(link)
    },
    /**
     * qq三国装备跳转
     */
    emegencyNotice2Click() {
      this.$router.push({
        path: 'selectGame',
        name: 'SelectGame',
        query: {game_id: '15', game_alias: 'games'},
        params: {game_name: 'QQ三国', game_class: '网路游戏', game_id: '15', productTypeSelect: 2}
      })
    },
    /**
     * 判断文本是否溢出
     * 特殊：如果文字长度刚好达到某个临界值，会出现不及时刷新出现按钮的情况，解决方案：使用this.$nextTick强制刷新
     */
    showDetailBtnFun() {
      this.$nextTick(() => {
        this.detailDom = this.$refs.detailDom;
        try{
          this.showDetailBtn = this.detailDom.clientHeight < this.detailDom.scrollHeight;
        }catch(e){}
      })
    },
    /**
     * 商品浏览记录添加
     */
    historyProductAdd() {
      apiHistoryProductAdd({
        game_id: this.game_id,
        product_id: this.id,
        product_type: 1
      })
    },
    /**
     * 商品客服咨询记录添加
     */
    historySerAdd() {
      apiHistoryCusAdd({
        game_id: this.game_id,
        product_id: this.id,
        product_type: 1
      })
    },
    /**
     * 访问统计
     * @constructor
     */
    statisticsAdd(statistics_type) {
      apiStatisticsAdd({
        game_id: this.game_id,
        product_id: this.id,
        statistics_type: statistics_type
      })
    },
    /**
     * 立即购买按钮
     */
    onlineBuy(){
      if (!this.$store.state.loginStatus) {
        this.$message({
          type: "error",
          message: '尚未登录，请先登录。',
          center: true
        })
        this.$router.push({
          path: '/login',
          query: {
            Rurl: this.$route.fullPath,
            game_name: this.game_name,
            game_id: this.game_id,
            id: this.id,
          },
        })
        return;
      }
      apiProductBuyCheck({
        game_id:this.game_id,
        id:this.id,
      }).then(res=>{
        let routeUrl = this.$router.resolve({
          name: 'OnlineDeal',
          query: {
            id: this.id,
            game_id:this.game_id
          }
        });
        window.open(routeUrl.href, '_blank');
        // this.$router.push({name:'OnlineDeal',query:{id:this.id,game_id:this.game_id}})
      }).catch(e => {
        this.$message.error(e.msg)
      })
    },

    /**
     * 商品详情页操作 - 神策埋点
     */
    ProductDetailOperation(operation_type){
      let type = ''
      switch (operation_type) {
        case 'collect':
          type = '点击收藏'
          break;
        case 'share':
          type = '点击分享'
          break;
        case 'priceCut':
          type = '求降价'
          break;
        case 'buy':
          type = '立即购买'
          break;
      }
      this.$sensorsTrack.ProductDetailOperation(type,`${this.accountInfo.game_alias}_${this.id}`,this.game_name,this.game_id,this.accountInfo.user_id,false)

    }
  },
  mounted() {
    //初始化数据
    this.onLoad()
    this.loadDto()
    this.historyProductAdd()
    this.statisticsAdd(2)
    this.detailDom = this.$refs.detailDom;
    this.showDetailBtnFun();
    window.addEventListener('resize', this.showDetailBtnFun);
    apiGameInfo({
      id: this.$route.query.game_id
    }).then(res => {
      this.sys_service_type = res.data.sys_service_type
      this.is_online_purchase = res.data.is_online_purchase
      this.is_open_trans_chat = res.data.is_open_trans_chat
      this.self_publicize = res.data.self_publicize
    })
  },
  watch: {},
  computed: {
    // F-01 守卫：content / cdata 契约应为富文本 HTML，但采集链路可能误写裸 JSON
    // （trim 后以 { 或 [ 开头），或写入不含任何 HTML 标签的纯文本。两种情况都不是
    // 用户需要看的富文本，直接不渲染该块，避免把后端原始数据泄露给用户。
    // 同页「游戏资产」页签（DetailDTO）是该采集数据的唯一规范出口。
    richContent() {
      return this.asRichText(this.accountInfo && this.accountInfo.content)
    },
    richCdata() {
      return this.asRichText(this.accountInfo && this.accountInfo.cdata)
    },
    tagList() {
      return this.accountInfo?.intelligent_pricing?.mainImportantKeys || []
    },
    //采集源图片详情(DetailDTO.gallery.detail)
    detailImages() {
      return (this.dto && this.dto.gallery && this.dto.gallery.detail) || []
    },
    //游戏资产 tab：有结构化资产 或 有数据概览(段位/分路段位/印记/职业分布) 即展示
    showAssetsTab() {
      if (!this.dto) return false
      if (this.dto.assets && this.dto.assets.has) return true
      const s = this.dto.summary && this.dto.summary.stats
      return !!(s && ((s.basic && s.basic.length) || (s.lane_rank && s.lane_rank.length) ||
        (s.marks && s.marks.length) || (s.profession && s.profession.length)))
    },
    showBargin() {
      return (this.accountInfo.can_bargain && this.accountInfo.accept_bargain == 1) ||  (this.accountInfo.can_bargain == 0 && this.accountInfo.is_premium == 1)
    }
  },
  created() {
    document.title = ''
  },
  beforeRouteLeave(to, from, next) {
    if (to.name !== 'GameDetails') {
      document.title = '游严选网络游戏账号交易代售平台-签署合同让交易享受法律保护'
      next()
    }
  }


}
</script>

<style lang="less">
.reductionDia {
  width: 358px;
  background: #FFFFFF;
  border-radius: 4px;
  position: relative;
  overflow: visible;

  .el-dialog__body {
    padding: 0px;
    position: relative;

    #UPS_main {
      display: flex;
      flex-direction: column;
      align-items: center;

      .UPS_info {
        display: flex;
        flex-direction: column;
        align-items: center;
        .reductionbg{
          background: #FFF6EC;
          padding: 25px 14px;
          box-sizing: border-box;
          border-radius: 0 0 4px 4px;
          .reductionbg_price{
            width: 300px;
            height: 90px;
            background:  url("../../../assets/image/AllGame/gameDetails/reductionbg.png") no-repeat;
            background-size: 100% 100%;
            display: flex;
            align-items: center;
            .reductionbg_price_left{
              display: flex;
              flex-direction: column;
              width: 125px;
              color: #FF6060;
              align-items: center;
              >div{
                &:first-child{
                  font-size: 14px;
                  span{
                    font-size: 24px;
                    font-weight: 500;
                  }
                }
                &:last-child{
                  font-size: 12px;
                  border: 1px solid #FF6060;
                  padding: 2px 6px;
                }
              }
            }
            .reductionbg_price_right{
              display: flex;
              flex-direction: column;
              width: 175px;
              align-items: flex-start;
              justify-content: center;
              >div{
                padding: 0 24px;
                &:first-child{
                  font-size: 12px;
                  font-family: PingFang SC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #C7C7C7;
                }
                &:last-child{
                  margin-top: 5px;
                  font-size: 12px;
                  font-family: PingFang SC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #949494;
                }
              }
            }
          }
          .reduction_btn{
            cursor: pointer;
            margin-top: 25px;
            line-height: 40px;
            text-align: center;
            border-radius: 4px;
            width: 300px;
            height: 40px;
            background: linear-gradient(90deg, #EC5E29 0%, #F09436 100%);
            font-size: 14px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #FFFFFF;
          }
        }
      }
    }
    .UPS_close {
      position: absolute;
      bottom: -47px;
      left: 187px;
      cursor: pointer;
      width: 30px;
      height: 30px;
    }
  }

  .el-dialog__header {
    padding: 0;
  }
}
.first_content img, .second_content img, .third_content img {
  max-width: 100%;
  object-fit: cover;
  background: #D8D8D8;
  border-radius: 4px;
  margin: 0 0 9px 0;
}

.add_price_confirm {
  width: 500px !important;
  height: 300px !important;
  background: var(--bg-card, #FFFFFF) !important;
  border-radius: 4px !important;
  padding: 0;
  border: 1px solid var(--border-soft, #E8E4DE);
  box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));

  .el-message-box__header > .el-message-box__title {
    display: none;
  }

  .el-message-box__header, .el-message-box__content {
    display: flex;
    flex-direction: column;
    padding: 0 0 0 70px;
  }

  .el-message-box__btns {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0;
  }

  .el-message-box__title {
    margin-top: 38px;
    font-size: 20px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 400;
    color: var(--text-main, #111827);
    line-height: 28px;
  }

  .el-message-box__container {
    margin-top: 63px;
    font-size: 16px;
    font-family: PingFangSC-Thin, PingFang SC;
    font-weight: 400;
    color: var(--text-secondary, #5A5F6B);
    line-height: 22px;
  }

  .change_price_confirm_btn {
    margin-top: 20px;
    padding: 0;
    width: 200px;
    height: 40px;
    line-height: 40px;
    background: var(--primary, #FF7A1A) !important;
    border-radius: 4px;
    border: none;
    font-size: 18px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 400;
    color: #FFFFFF !important;
  }

  .change_price_confirm_btn:hover {
    background: var(--primary-hover, #F97316) !important;
  }

  .confirm_content {
    display: flex;
    flex-direction: column;
  }

  .confirm_original_price {
    font-size: 20px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 400;
    color: var(--primary, #FF7A1A);
    line-height: 28px;
    margin-bottom: 20px;
  }

  .confirm_my_bid {
    font-size: 20px;
    font-family: PingFangSC-Thin, PingFang SC;
    font-weight: 400;
    color: var(--text-secondary, #5A5F6B);
    line-height: 28px;
    margin-bottom: 20px;
  }

  .confirm_modify_bid {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .confirm_modify_bid_text {
    font-size: 20px;
    font-family: PingFangSC-Thin, PingFang SC;
    font-weight: 400;
    color: var(--text-secondary, #5A5F6B);
    line-height: 28px;
  }

  .confirm_modify_bid_input {
    width: 210px;
    height: 40px;
    background: var(--bg-section, #F7F5F2);
    border-radius: 4px;
    border: 1px solid var(--border-soft, #E8E4DE);
    padding: 0 20px;
    font-size: 16px;
    font-family: PingFangSC-Thin, PingFang SC;
    font-weight: 300;
    line-height: 22px;
  }

  .confirm_modify_bid_tips {
    font-size: 16px;
    font-family: PingFangSC-Thin, PingFang SC;
    font-weight: 400;
    color: var(--text-muted, #9AA0AC);
    line-height: 22px;
    margin-left: 100px;
  }

  .confirm_modify_bid_input::-webkit-input-placeholder {
    font-size: 16px;
    font-family: PingFangSC-Thin, PingFang SC;
    font-weight: 300;
    color: #D1D1D1;
  }
}

.change_price_confirm {
  width: 500px !important;
  height: 320px !important;
  background: var(--bg-card, #FFFFFF) !important;
  border-radius: 4px !important;
  padding: 0;
  border: 1px solid var(--border-soft, #E8E4DE);
  box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));

  .el-message-box__header > .el-message-box__title {
    display: none;
  }

  .el-message-box__header, .el-message-box__content {
    display: flex;
    flex-direction: column;
    padding: 0 0 0 70px;
  }

  .el-message-box__btns {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0;
  }

  .el-message-box__title {
    margin-top: 38px;
    font-size: 20px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 400;
    color: var(--text-main, #111827);
    line-height: 28px;
  }

  .el-message-box__container {
    margin-top: 34px;
    font-size: 16px;
    font-family: PingFangSC-Thin, PingFang SC;
    font-weight: 400;
    color: var(--text-secondary, #5A5F6B);
    line-height: 22px;
  }

  .change_price_confirm_btn {
    margin-top: 20px;
    padding: 0;
    width: 200px;
    height: 40px;
    line-height: 40px;
    background: var(--primary, #FF7A1A) !important;
    border-radius: 4px;
    border: none;
    font-size: 18px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 400;
    color: #FFFFFF !important;
  }

  .change_price_confirm_btn:hover {
    background: var(--primary-hover, #F97316) !important;
  }

  .confirm_content {
    display: flex;
    flex-direction: column;
  }

  .confirm_original_price {
    font-size: 20px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 400;
    color: var(--primary, #FF7A1A);
    line-height: 28px;
    margin-bottom: 20px;
  }

  .confirm_my_bid {
    font-size: 20px;
    font-family: PingFangSC-Thin, PingFang SC;
    font-weight: 400;
    color: var(--text-secondary, #5A5F6B);
    line-height: 28px;
    margin-bottom: 20px;
  }

  .confirm_modify_bid {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .confirm_modify_bid_text {
    font-size: 20px;
    font-family: PingFangSC-Thin, PingFang SC;
    font-weight: 400;
    color: var(--text-secondary, #5A5F6B);
    line-height: 28px;
  }

  .confirm_modify_bid_input {
    width: 210px;
    height: 40px;
    background: var(--bg-section, #F7F5F2);
    border-radius: 4px;
    border: 1px solid var(--border-soft, #E8E4DE);
    padding: 0 20px;
    font-size: 16px;
    font-family: PingFangSC-Thin, PingFang SC;
    font-weight: 300;
    line-height: 22px;
  }

  .confirm_modify_bid_tips {
    font-size: 16px;
    font-family: PingFangSC-Thin, PingFang SC;
    font-weight: 400;
    color: var(--text-muted, #9AA0AC);
    line-height: 22px;
    margin-left: 100px;
  }

  .confirm_modify_bid_input::-webkit-input-placeholder {
    font-size: 16px;
    font-family: PingFangSC-Thin, PingFang SC;
    font-weight: 300;
    color: #D1D1D1;
  }
}

.contactCusSer {
  width: 500px;
  background: #FFFFFF;
  border-radius: 4px;
  position: relative;
  overflow: visible;

  .el-dialog__body {
    padding: 10px 15px 20px;
    position: relative;

    #contactCusSer {
      width: 470px;

      .contactCusSer_title {
        background: #313131;
        color: #FFFFFF;
        text-align: center;
        border-radius: 4px;
        height: 33px;
        line-height: 33px;
        font-size: 20px;
      }

      .contactCusSer_list {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin: 20px 0 0 0;

        .CL_item {
          width: 450px;
          height: 26px;
          margin: 0 0 10px 0;
          display: flex;
          flex-direction: row;
          justify-content: space-between;

          div {
            font-size: 18px;
            font-family: PingFangSC-Regular, PingFang SC;
            color: #000000;
          }

          .CL_btn {
            width: 120px;
            display: flex;
            flex-direction: row;

            div, a {
              margin: 0 10px 0 0;
              font-size: 16px;
              background: rgb(255, 219, 81);
              width: 54px;
              height: 26px;
              line-height: 26px;
              text-align: center;
              border-radius: 4px;
              cursor: pointer;
            }

            a {
              margin: 0;
              background: #f19958;
            }

          }

          #input {
            position: absolute;
            top: 0;
            left: 0;
            opacity: 0;
            z-index: -10;
          }
        }
      }

      .onlineCus {
        margin: 20px auto;
        width: 100px;
        text-align: center;
        background-color: rgb(255, 219, 81);
        color: black;
        padding: 10px 18px;
        font-weight: bold;
        font-size: 16px;
        border-radius: 4px;
        cursor: pointer;
        user-select: none;
        display: block;
      }

      .contactCusSer_tip {
        text-align: center;
        color: black;
        margin: 4px 0 0 0;
        //font-weight: 600;
        font-weight: 400;
        font-family: PingFangSC-Regular, PingFang SC;
        font-size: 14px;

        span {
          display: inline-block;
          color: #FF5454;
        }
      }
    }
  }

  .el-dialog__header {
    padding: 0;
  }
}
</style>

<style lang="less" scoped>
.ql-container {
  border: none !important;
}

/deep/ .ql-editor {
  min-height: 120px;
  padding: 20px;
  color: var(--text-main, #111827);
  font-size: 15px;
  line-height: 1.8;
  background: var(--bg-card, #FFFFFF);
}

/deep/ .el-tabs__nav-wrap::after {
  content: none;
}

/deep/ .el-tabs__header,
/deep/ .el-tabs__nav-wrap,
/deep/ .el-tabs__nav-scroll {
  overflow: visible;
}

/deep/ .el-tabs__nav-scroll, /deep/ .el-tabs__nav {
  height: 56px;
  display: flex;
  align-items: center;
}

/deep/ .el-tabs__nav {
  gap: 12px;
}

/deep/ .el-tabs__item {
  position: relative;
  height: 40px;
  font-size: 16px;
  font-family: PingFangSC-Thin, PingFang SC;
  font-weight: 400;
  color: var(--text-secondary, #5A5F6B);
  line-height: 40px;
  padding: 0 22px !important;
  border-radius: 0;
  background: transparent;
  z-index: 0;
  transition: color 0.2s ease;
}

/* 斜切平行四边形底（文字保持正立） */
/deep/ .el-tabs__item::before {
  content: "";
  position: absolute;
  inset: 0;
  background: var(--bg-tag, #F0EDE8);
  transform: skewX(-12deg);
  border-radius: 2px;
  z-index: -1;
  transition: background 0.2s ease;
}

/deep/ .el-tabs__item:hover {
  color: var(--text-main, #1A1D24);
  background: transparent;
}

/deep/ .el-tabs__item:hover::before {
  background: var(--border-soft, #E8E4DE);
}

/deep/ .el-tabs__header {
  box-shadow: none !important;
}

/* 激活态三件套：深炭斜切底 + 左上橙缺角 + 底部橙能量条 */
/deep/ .el-tabs__item.is-active {
  background: transparent;
  box-shadow: none;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #FFFFFF;
  line-height: 40px;
}

/deep/ .el-tabs__item.is-active::before {
  background: var(--bg-dark, #1A1D24);
}

/deep/ .el-tabs__item.is-active::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: -3px;
  width: 100%;
  height: 3px;
  background: var(--primary, #FF5A1F);
  z-index: 1;
}

/deep/ .el-tabs__active-bar.is-top {
  height: 0px;
}

/deep/ .el-tabs__header {
  margin: 0 0 24px;
  padding: 16px 40px 0;
  position: relative;
  height: 72px;
  box-sizing: border-box;
}

/deep/ .el-tabs__content {
  padding: 0 40px 40px 40px;
}

.game_details {
  width: 1200px;

  .title {
    height: 60px;
    display: flex;
    align-items: center;
    margin-left: 5px;

    a {
      font-size: 14px;
      font-family: PingFangSC-Thin, PingFang SC;
      font-weight: 400;
      color: var(--text-secondary, #5A5F6B);
      transition: color 0.2s ease;
      display: inline-flex;
      align-items: center;

      &:hover {
        color: var(--primary, #FF5A1F);
      }

      .Breadcrumb {
        display: inline-block;
        width: 7px;
        height: 11px;
        background: var(--border-soft, #E8E4DE);
        transform: skewX(-20deg);

        i {
          display: none;
        }
      }
    }

    a:last-of-type {
      font-size: 14px;
      font-family: PingFangSC-Light, PingFang SC;
      font-weight: 600;
      color: var(--text-main, #1A1D24);
      cursor: pointer;

      &:hover {
        color: var(--text-main, #1A1D24);
      }
    }
  }

  .details {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 372px;
    gap: 10px 20px;
    align-items: start;

    > .details_info { grid-column: 1; }
    > .pdp-side {
      grid-column: 2;
      grid-row: 1 / span 99;
      align-self: start;
      position: sticky;
      top: 14px;
      min-width: 0;
    }
    > .DI_productName,
    > .DI_links,
    > .details_tabbar {
      grid-column: 1;
      width: auto;
    }

    .pdp-side .tcard {
      background: var(--bg-card, #FFFFFF);
      border: 1px solid var(--border-soft, #E8E4DE);
      border-radius: 4px;
      box-shadow: var(--shadow-card, 0 8px 22px rgba(26, 29, 36, 0.08));
      overflow: hidden;
    }

    .details_info {
      padding: 14px;
      background-color: var(--bg-card, #FFFFFF);
      border: 1px solid var(--border-soft, #E8E4DE);
      border-radius: 4px;
      box-shadow: var(--shadow-card, 0 8px 22px rgba(26, 29, 36, 0.08));
      margin-bottom: 0;
      display: block;

      .DI_base_img {
        position: relative;
        margin: 0;
        overflow: hidden;
        height: 360px;
        border-radius: 4px;
        background:
          radial-gradient(120% 90% at 78% 12%, rgba(255, 90, 31, 0.20), transparent 55%),
          linear-gradient(115deg, #171b22 0%, #0e1116 60%, #1d1410 100%);
        display: flex;
        align-items: center;
        justify-content: center;

        &::before {
          content: "";
          position: absolute;
          inset: 0;
          background-image:
            linear-gradient(rgba(255, 255, 255, 0.03) 1px, transparent 1px),
            linear-gradient(90deg, rgba(255, 255, 255, 0.03) 1px, transparent 1px);
          background-size: 40px 40px;
          -webkit-mask-image: linear-gradient(180deg, transparent, #000 60%);
          mask-image: linear-gradient(180deg, transparent, #000 60%);
          z-index: 1;
          pointer-events: none;
        }

        &::after {
          content: "";
          position: absolute;
          top: 0;
          left: -40%;
          width: 28%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.06), transparent);
          transform: skewX(-20deg);
          animation: stageSweep 3s var(--ease, cubic-bezier(.22, .9, .24, 1)) infinite;
          z-index: 1;
          pointer-events: none;
        }

        /deep/ .el-image,
        /deep/ img {
          position: relative;
          z-index: 2;
        }
      }

      @keyframes stageSweep {
        0% { left: -40%; }
        60%, 100% { left: 120%; }
      }
    }

    .DI_base_content {
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 2px;
        padding: 16px 18px 4px;
        box-sizing: border-box;
        /deep/.DI_prodct_tip {
            height: 32px;
            background: var(--warning-soft, #FFFBEB);
            border: 1px solid rgba(245, 158, 11, 0.18);
            border-radius: 4px;
            padding: 0 20px;
            font-size: 14px;
            font-family: PingFangSC-Light, PingFang SC;
            font-weight: 400;
            color: var(--warning, #F59E0B);
            line-height: 32px;
          }

        /deep/.DI_prodct_price {
            min-height: 72px;
            background: var(--bg-dark, #1A1D24);
            border: 1px solid var(--bg-dark, #1A1D24);
            border-radius: 4px;
            padding: 12px 16px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;

            #DI_prodct_price {
              display: flex;
              align-items: center;
              flex-direction: row;
              flex-wrap: wrap;
              font-size: 13px;
              font-family: PingFangSC-Thin, PingFang SC;
              font-weight: 400;
              color: #aeb4be;
              margin: 0 10px 0 0;

              > .price {
                font-size: 36px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 800;
                color: var(--primary, #FF7A1A);
                margin: 0 10px 0 0;
                max-width: 250px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }

              .renewalTap {
                display: flex;
                margin: 0 0 0 10px;
                position: relative;

                img {
                  width: 80px;
                  height: 20px;
                }

                .renewalTooltip {
                  display: none;
                  position: absolute;
                  bottom: -55px;
                  left: -60px;
                  width: 180px;
                  height: 48px;
                  line-height: 48px;
                  text-align: center;
                  background: var(--bg-card, #FFFFFF);
                  box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
                  opacity: 1;
                  border: 1px solid var(--border-soft, #E8E4DE);
                  font-size: 14px;
                  font-family: PingFang SC-Medium, PingFang SC;
                  font-weight: 500;
                  color: var(--brand-blue, #1A1D24);
                  border-radius: 4px;

                  &::before {
                    right: 50px;
                    top: -11px;
                    content: "";
                    display: block;
                    width: 0;
                    height: 0;
                    border-bottom: solid 10px;
                    border-right: solid 5px;
                    border-left: solid 5px;
                    border-color: rgba(255, 255, 255, 0) rgba(255, 255, 255, 0) var(--border-soft, #E8E4DE) rgba(255, 255, 255, 0);
                    position: absolute;
                    z-index: 2;
                  }

                  &::after {
                    right: 50px;
                    top: -9px;
                    content: "";
                    display: block;
                    width: 0;
                    height: 0;
                    border-bottom: solid 10px;
                    border-right: solid 5px;
                    border-left: solid 5px;
                    border-color: rgba(255, 255, 255, 0) rgba(255, 255, 255, 0) var(--bg-card, #FFFFFF) rgba(255, 255, 255, 0);
                    position: absolute;
                    z-index: 3;
                  }
                }
              }

              .renewalTap:hover {
                .renewalTooltip {
                  display: block;
                }
              }
            }

            #DI_prodct_hot {
              display: flex;
              flex-direction: row;
              align-items: center;
              flex: none;
              font-size: 15px;
              font-family: PingFangSC-Thin, PingFang SC;
              font-weight: 400;
              color: #aeb4be;

              img {
                margin: 0 6px 0 0;
                width: 17.38px;
                height: 20px;
              }
            }
          }

        /deep/.DI_prodct_zone {
            min-height: 50px;
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            //margin: 10px 0;
            padding: 6px 0;

            #DI_prodct_zone {
              width: 50%;
              display: flex;
              flex-direction: row;
              align-items: center;
              margin: 5px 0;

              .zone_title {
                max-width: 84px;
                min-width: 48px;
                font-size: 14px;
                font-family: PingFangSC-Thin, PingFang SC;
                font-weight: 400;
                color: var(--text-muted, #9AA0AC);
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }

              .zone_content {
                flex: 1;
                min-width: 0;
                max-width: 118px;
                text-align: center;
                font-size: 14px;
                font-family: PingFangSC-Thin, PingFang SC;
                font-weight: 400;
                color: var(--text-main, #111827);
                background: var(--brand-blue-light, #F0EDE8);
                border: 1px solid rgba(26, 29, 36, 0.12);
                border-radius: 3px;
                line-height: 26px;
                padding: 0 10px;
                box-sizing: border-box;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
          }

        /deep/.DI_prodct_promise {
            padding: 12px 0;
            margin-top: 4px;
            border-top: 1px solid var(--border-soft, #E8E4DE);
            border-bottom: 1px solid var(--border-soft, #E8E4DE);
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            align-items: center;
            gap: 6px 14px;

            .promise_title {
              font-size: 13px;
              font-family: PingFangSC-Thin, PingFang SC;
              font-weight: 400;
              color: var(--text-muted, #9AA0AC);
              line-height: 20px;
              margin: 0;
            }

            .promise_list {
              display: flex;
              flex-direction: row;
              flex-wrap: wrap;
              gap: 6px 14px;

              .promise_item {
                display: flex;
                flex-direction: row;
                align-items: center;
                font-size: 13px;
                font-family: PingFangSC-Light, PingFang SC;
                font-weight: 400;
                color: var(--text-secondary, #5A5F6B);
                margin: 0;

                img {
                  width: 20px;
                  height: 20px;
                  margin: 0 4px 0 0;
                }
              }

              .promise_item:last-of-type {
                margin: 0;
              }
            }
          }
        /deep/.DI_prodct_bottom{
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 5px 26px 0 18px;
          .prodct-bottom-left{
            display: flex;
            justify-content: flex-start;
            color: var(--text-secondary, #5A5F6B);
            font-family: PingFang SC;
            font-size: 16px;
            font-style: normal;
            font-weight: 300;
            line-height: normal;
            .collect{
              display: flex;
              justify-content: flex-start;
              align-items: center;
              margin-right: 25px;
            }
          }
          .prodct-bottom-right{
            color: var(--text-muted, #9AA0AC);
            font-family: PingFang SC;
            font-size: 14px;
            font-style: normal;
            font-weight: 300;
            line-height: normal;
            span{
              color: var(--text-main, #111827);
              margin-left: 11px;
            }
          }
        }
        /deep/.DI_prodct_addDate {
            margin: 11px 0 0 20px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;

            .times {
              font-size: 14px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: var(--brand-blue, #1A1D24);
              padding: 10px 40px 10px 20px;
              background: var(--brand-blue-light, #F0EDE8);
              border-radius: 4px;
              position: relative;

              .transactions_num {
                font-size: 20px;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                color: var(--primary, #FF7A1A);
                line-height: 28px;
              }
            }

            .times::before {
              position: absolute;
              content: '';
              z-index: 1;
              width: 0;
              height: 0;
              top: 14px;
              left: -14px;
              border-top: 10px solid transparent;
              border-right: 20px solid var(--brand-blue-light, #F0EDE8);
              border-bottom: 10px solid transparent;
            }

            .up_time {
              font-size: 14px;
              font-family: PingFangSC-Thin, PingFang SC;
              font-weight: 400;
              color: var(--text-muted, #9AA0AC);

              span {
                color: var(--text-main, #111827);
              }
            }

          }
      }

    .DI_btnGroup {
      width: 100%;
      min-height: 0;
      background: transparent;
      border: 0;
      border-radius: 0;
      box-shadow: none;
      padding: 4px 18px 18px;
      display: flex;
      flex-direction: column-reverse;
      align-items: stretch;
      justify-content: flex-start;
      gap: 12px;
      box-sizing: border-box;

      .DI_btnGroup_left {
        min-width: 0;
        width: 100%;
        display: flex;
        align-items: center;
        gap: 12px;

        /deep/.el-skeleton {
          width: 100%;
        }

        /deep/.el-skeleton__template {
          display: flex;
          align-items: center;
          gap: 16px;
        }

        .DI_btnGroup_left_inner {
          display: flex;
          align-items: center;
          gap: 12px;
          width: 100%;
          min-width: 0;
        }

        .shareBtnWrap {
          display: flex;
          align-items: center;
          flex: 1;
          min-width: 0;
        }

        /deep/.collectBtn, /deep/.isCollectBtn {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          flex: 1;
          min-width: 0;
          height: 46px;
          border-radius: 3px;
          border: 1px solid var(--border-soft, #E8E4DE);
          background: var(--bg-card, #FFFFFF);
          margin: 0;
          padding: 0 18px;
          box-sizing: border-box;
          font-size: 15px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: var(--primary, #FF7A1A);
          line-height: 44px;
          box-shadow: 0 4px 12px rgba(15, 23, 42, 0.04);
          transition: color 0.2s ease, background 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;

          i {
            margin: 0 8px 0 0;
            height: 20px;
            line-height: 20px;
            font-size: 20px;
            object-fit: contain;
            color: var(--primary, #FF7A1A);
          }
        }

        /deep/.collectBtn:hover, /deep/.isCollectBtn:hover {
          color: var(--primary, #FF7A1A);
          background: var(--primary-soft, #FFF3E7);
          border-color: rgba(255, 122, 26, 0.28);
          box-shadow: 0 6px 14px rgba(255, 122, 26, 0.1);
        }

        /deep/.collectBtn:hover i, /deep/.isCollectBtn:hover i {
          color: var(--primary, #FF7A1A);
        }

        /deep/.collectBtn:active, /deep/.isCollectBtn:active {
          background: #FFE8D3;
          box-shadow: 0 2px 8px rgba(255, 122, 26, 0.08);
        }

        /deep/.share,
        /deep/.shareBtn {
          display: flex;
          align-items: center;
        }

        /deep/.shareBtn {
          justify-content: center;
          width: 100%;
          min-width: 0;
          height: 46px;
          border-radius: 3px;
          border: 1px solid var(--border-soft, #E8E4DE);
          background: var(--bg-card, #FFFFFF);
          margin: 0;
          padding: 0 18px;
          box-sizing: border-box;
          font-size: 15px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: var(--text-secondary, #5A5F6B);
          line-height: 44px;
          box-shadow: 0 4px 12px rgba(15, 23, 42, 0.04);
          transition: color 0.2s ease, background 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;
        }

        /deep/.shareBtn i {
          margin: 0 8px 0 0;
          height: 20px;
          line-height: 20px;
          font-size: 20px;
          color: var(--brand-blue, #1A1D24);
        }

        /deep/.shareBtn:hover {
          color: var(--brand-blue, #1A1D24);
          background: var(--brand-blue-light, #F0EDE8);
          border-color: rgba(26, 29, 36, 0.28);
          box-shadow: 0 6px 14px rgba(26, 29, 36, 0.1);
        }

        /deep/.shareBtn:active {
          background: #F0EDE8;
          box-shadow: 0 2px 8px rgba(26, 29, 36, 0.08);
        }

        div {
          cursor: pointer;
          display: flex;
          flex-direction: row;
          align-items: center;
        }
      }

      .DI_btnGroup_right {
        width: 100%;
        display: flex;
        flex-direction: column-reverse;
        align-items: stretch;
        gap: 12px;

        /deep/.el-skeleton__template,
        /deep/.el-skeleton__content,
        > .el-skeleton {
          display: flex;
          flex-direction: column;
          align-items: stretch;
          gap: 12px;
        }

        div{
          display: flex;
          flex-direction: column-reverse;
          align-items: stretch;
          gap: 12px;
          width: 100%;
        }

        /deep/.btn {
          cursor: pointer;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          width: 100%;
          min-width: 0;
          height: 50px;
          border-radius: 3px;
          border: 1px solid transparent;
          padding: 0 20px;
          box-sizing: border-box;
          font-size: 17px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 500;
          color: #FFFFFF;
          line-height: 48px;
          text-align: center;
          margin-top: 0;
          user-select: none;
          transition: background 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease, color 0.2s ease, filter 0.2s ease;
        }

        /deep/.btn:active {
          box-shadow: 0 2px 8px rgba(15, 23, 42, 0.08);
        }

        /deep/.priceCutBtn {
          width: 100%;
          background: var(--bg-card, #FFFFFF);
          color: var(--brand-blue, #1A1D24);
          border: 1px solid rgba(26, 29, 36, 0.28);
          box-shadow: 0 4px 12px rgba(15, 23, 42, 0.04);
        }

        /deep/.priceCutBtn:hover {
          background: var(--brand-blue-light, #F0EDE8);
          border-color: var(--brand-blue, #1A1D24);
          box-shadow: 0 6px 14px rgba(26, 29, 36, 0.12);
        }

        /deep/.onlineDealBtn {
          width: 100%;
          height: 54px;
          line-height: 52px;
          font-size: 18px;
          font-weight: 800;
          background: var(--primary, #FF5A1F);
          box-shadow: 0 6px 16px rgba(255, 90, 31, 0.16);
        }

        /deep/.onlineDealBtn:hover {
          background: var(--primary-hover, #E84A12);
          box-shadow: 0 8px 20px rgba(255, 90, 31, 0.20);
        }

        /deep/.cusSerBtn {
          width: 100%;
          height: 50px;
          border: 1px solid var(--border-soft, #E8E4DE);
          background: var(--bg-card, #FFFFFF);
          color: var(--text-main, #111827);
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 4px 12px rgba(15, 23, 42, 0.04);
        }

        /deep/.cusSerBtn:hover {
          color: var(--brand-blue, #1A1D24);
          background: var(--brand-blue-light, #F0EDE8);
          border-color: rgba(26, 29, 36, 0.28);
          box-shadow: 0 6px 14px rgba(26, 29, 36, 0.1);
        }
      }
    }

    .DI_productName {
      margin: 0;
      width: auto;
      background: var(--bg-card, #FFFFFF);
      border: 1px solid var(--border-soft, #E8E4DE);
      border-radius: 4px;
      box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
      padding: 22px 24px;
      font-size: 20px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 800;
      letter-spacing: -0.3px;
      color: var(--text-main, #1A1D24);
      line-height: 32px;
      text-align: justify; /*实现两端对齐*/
      text-justify: newspaper; /*通过增加或减少字或字母之间的空格对齐文本*/
      word-break: break-all; /*允许在单词内换行*/
      overflow: hidden;
      position: relative;
      &::after{
        content: '';
        position: absolute;
        width: calc(100% - 48px);
        height: 20px;
        bottom: 0;
        background: var(--bg-card, #FFFFFF);
        z-index: 2;
      }
      @keyframes tag-bounce {
        0%{
          transform: translateY(calc(100% + 17px));
        }
       20%{
          transform: translateY( -40%);
        }
        40%{
          transform: translateY( 30%);
        }
        65%{
          transform: translateY( -5%);
        }
        90%{
          transform: translateY( 5%);
        }
        100%{
          transform: translateY(0);
        }
      }
      .tag{
        animation: tag-bounce 0.7s ease-out  1 0.3s  forwards;
        margin-bottom: 17px;
        transform: translateY(calc(100% + 17px));
        z-index: -1;
        .el-tag{
          color: var(--primary, #FF7A1A);
          background: var(--primary-soft, #FFF3E7);
          border-color: rgba(255, 122, 26, 0.18);
          margin-right: 8px;
        }
      }
      .DI_productName_hide, .DI_productName_show {
        position: relative;
        z-index: 2;
        background: var(--bg-card, #FFFFFF);
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;

        .DI_productName_title {
          display: inline-block;
          background: var(--bg-dark, #1A1D24);
          border: 0;
          border-radius: 2px;
          font-size: 13px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 700;
          color: #FFFFFF;
          padding: 3px 10px;
          margin-right: 8px;
          letter-spacing: 0;
          vertical-align: 2px;
        }
      }

      .DI_productName_show {
        display: block;
      }

      .DI_productName_btn {
        margin: 15px 0 0;
        text-align: center;
        cursor: pointer;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 500;
        color: var(--text-muted, #9AA0AC);
        line-height: 22px;
      }

      .DI_productName_btn:hover {
        color: var(--brand-blue, #1A1D24);
      }
    }

    .DI_links {
      width: auto;
      background: var(--bg-card, #FFFFFF);
      border: 1px solid var(--border-soft, #E8E4DE);
      border-radius: 4px;
      box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
      padding: 20px 24px;
      margin: 0;

      /deep/.labels {
        display: flex;
        flex-direction: row;
        a,div{
          flex: 1;
          text-align: center;
          margin: 0 11px 0 0;
          padding: 11px 10px;
          border-radius: 3px;
          border: 1px solid var(--border-soft, #E8E4DE);
          font-size: 16px;
          font-family: PingFang SC,PingFang SC-Medium;
          font-weight: 500;
          color: var(--text-secondary, #5A5F6B);
          background: var(--bg-section, #F7F5F2);
          transition: color 0.2s ease, background 0.2s ease, border-color 0.2s ease;
        }
        & > span {
          margin-left: 11px;
          cursor: pointer;
          flex: 1;
          display: flex;
        }
        div{
          margin:0 0 0 11px ;
          cursor: default !important;
        }
        a:last-of-type {
          margin: 0;
        }
        a:hover,div:hover {
          color: var(--brand-blue, #1A1D24);
          background: var(--brand-blue-light, #F0EDE8);
          border: 1px solid rgba(26, 29, 36, 0.24);
        }
      }
    }

    .details_tabbar {
      //padding: 40px 40px 58px 40px;
      //padding: 0px 40px 58px 40px;
      background-color: var(--bg-card, #FFFFFF);
      border: 1px solid var(--border-soft, #E8E4DE);
      border-radius: 4px;
      box-shadow: var(--shadow-card, 0 8px 22px rgba(26, 29, 36, 0.08));

      .Tip {
        position: relative;

        .JL_tip {
          width: 100%;
        }

        .JL_tipBtn {
          position: absolute;
          bottom: 90px;
          right: 200px;
          cursor: pointer;
        }

        .JL_tipBtn:hover {
          animation: header_fourMove 0.2s linear infinite; // 重点，定义动画
          animation-fill-mode: forwards;
          animation-iteration-count: 1;
          @keyframes header_fourMove {
            0% {
              transform: translateY(0);
            }
            100% {
              transform: translateY(-2px);
            }
          }
        }
      }

      .Tip12 {
        position: relative;

        .JL_tip {
          width: 100%;
        }

        .tipBtn {
          position: absolute;
          bottom: 70px;
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 100%;

          img:hover {
            cursor: pointer;
            animation: header_fourMove 0.2s linear infinite; // 重点，定义动画
            animation-fill-mode: forwards;
            animation-iteration-count: 1;
            @keyframes header_fourMove {
              0% {
                transform: translateY(0);
              }
              100% {
                transform: translateY(-2px);
              }
            }
          }
        }

      }

      .detail_gallery {
        display: flex;
        flex-direction: column;
        margin-bottom: 9px;

        .detail_gallery_img {
          width: 100%;
          display: block;
          border-radius: 4px;
          margin-bottom: 9px;
          background: var(--bg-section, #F3F0EB);
          cursor: zoom-in;

          img {
            width: 100%;
            height: auto;
            display: block;
          }
        }
      }

      .first_content {
        width: auto;
        overflow: hidden;
        border: 1px solid var(--border-soft, #E8E4DE) !important;
        border-radius: 4px;
        background: var(--bg-card, #FFFFFF);
        margin-bottom: 9px;
      }

      .second_content {
        width: auto;
        overflow: hidden;
        border: 1px solid var(--border-soft, #E8E4DE) !important;
        border-radius: 4px;
        background: var(--bg-card, #FFFFFF);
        margin-bottom: 9px;
      }

      .third_content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        color: var(--text-main, #111827);
        line-height: 1.8;

        .third_content_item {
          margin-bottom: 50px;

          .content_item_title {
            display: flex;
            flex-direction: row;
            margin-bottom: 21px;

            div:first-of-type {
              margin-right: 20px;
            }

            div:last-of-type {
            font-size: 20px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 600;
            color: var(--primary, #FF7A1A);
            }
          }

          .content_item_content {
            font-size: 16px;
            font-family: PingFangSC-Thin, PingFang SC;
            font-weight: 400;
            color: var(--text-main, #111827);
            line-height: 25px;

            img {
              width: 100%;
              height: 128px;
              object-fit: cover;
            }
          }
        }

        .third_content_item:last-of-type {
          margin-bottom: 0;
        }

        .third_content_item:first-of-type {
          margin-bottom: 41px;
        }
      }

      .fourth_content {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-items: center;

        .fourth_content_item {
          width: 50%;

          .fourth_content_item_box {
            display: flex;
            flex-direction: row;
            align-items: center;
            margin: 15px 0;

            div:first-of-type {
              margin-right: 20px;
            }

            .qq_logo {
              margin-right: 10px;
            }

            .group_name {
              font-size: 20px;
              font-family: PingFangSC-Thin, PingFang SC;
              font-weight: 400;
              color: var(--text-main, #111827);
              line-height: 28px;
              margin-right: 30px;
            }

            .add_group {
              width: 100px;
              height: 40px;
              background: var(--brand-gradient, linear-gradient(135deg, #1A1D24 0%, #1A1D24 100%));
              border-radius: 4px;
              font-size: 20px;
              font-family: PingFangSC-Light, PingFang SC;
              font-weight: 400;
              color: #FFFFFF;
              line-height: 40px;
              text-align: center;
            }
          }
        }
      }
    }
  }

  .showFalse {
    width: 300px;
    //height: 285px;
    background: var(--bg-card, #FFFFFF);
    border: 1px solid var(--border-soft, #E8E4DE);
    border-radius: 4px;
    box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
    padding: 50px 450px 70px;

    .showFalse_tip {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 0 0 39px 0;

      img {
        width: 229px;
        height: 150px;
        object-fit: cover;
        //margin: 0 0 6px 0;
      }

      #tip {
        font-size: 14px;
        font-family: PingFangSC-Thin, PingFang SC;
        font-weight: 300;
        color: #9A9A9A;
        line-height: 20px;
      }
    }

    .showFalse_btnG {
      display: flex;
      flex-direction: column;
      align-items: center;

      a {
        width: 300px;
        height: 50px;
        border-radius: 4px;
        text-align: center;
        line-height: 50px;
        font-size: 18px;
        font-family: PingFangSC-Light, PingFang SC;
        font-weight: 400;
        color: var(--text-main, #111827);
        transition: color 0.2s ease, background 0.2s ease, border-color 0.2s ease;
      }

      #back {
        background: var(--primary, #FF7A1A);
        color: #FFFFFF;
        margin: 0 0 8px 0;
      }

      #back:hover {
        background: var(--primary-hover, #F97316);
      }

      .cusSer {
        border: 1px solid var(--border-strong, #CBD5E1);
        color: var(--text-secondary, #5A5F6B);
      }

      .cusSer:hover {
        color: var(--brand-blue, #1A1D24);
        border-color: var(--brand-blue, #1A1D24);
        background: var(--brand-blue-light, #F0EDE8);
      }
    }
  }

}

.dialog-footer {
  margin-top: 10px;
   .el-button{
    border-radius: 4px;
    width: 140px;
    height: 40px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
  }
    .btn-cancel{
      border: 1px solid var(--border-strong, #CBD5E1);
      background: var(--bg-card, #FFFFFF);
      color: var(--text-secondary, #5A5F6B);
  }
  .btn-confirm{
      background: var(--primary, #FF7A1A);
      color: #FFFFFF;
      border-color: var(--primary, #FF7A1A);
  }
}
.wait,.reBargin{
  width: 140px;
  border-radius: 4px;
  color: var(--text-secondary, #5A5F6B);
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: 500;
  background: var(--bg-card, #FFFFFF);
  border-color: var(--border-strong, #CBD5E1);
}
.reBargin{
  border: none;
  background: var(--primary, #FF7A1A);
  color: #FFFFFF;
}
</style>
